import { render, staticRenderFns } from "./TeethList.vue?vue&type=template&id=11926c09&scoped=true"
import script from "./TeethList.vue?vue&type=script&lang=js"
export * from "./TeethList.vue?vue&type=script&lang=js"
import style0 from "./TeethList.vue?vue&type=style&index=0&id=11926c09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11926c09",
  null
  
)

export default component.exports